export const trackEvent = (eventName, properties = {}) => {
  if (!eventName) return;

  // Google Tag Manager
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...properties,
    });
  }

  // Meta Pixel
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, properties);
  }

  // PostHog (when initialized globally)
  if (
    typeof window !== "undefined" &&
    window.posthog &&
    typeof window.posthog.capture === "function"
  ) {
    window.posthog.capture(eventName, properties);
  }
};
